import React from 'react';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { formatPeriodo, getPreviousPeriods } from '../../lib/utils';

export const PeriodSelector = ({ value, onChange, periods = null, placeholder = "Seleccionar período" }) => {
  const availablePeriods = periods || getPreviousPeriods(24);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full md:w-[200px]" data-testid="period-selector">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {availablePeriods.map((periodo) => (
          <SelectItem key={periodo} value={periodo} data-testid={`period-option-${periodo}`}>
            {formatPeriodo(periodo)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default PeriodSelector;
